import { cva } from "class-variance-authority";

export const navButtonVariants = cva(
  [
    "inline-flex items-center justify-center",
    "rounded-full transition-colors cursor-pointer",
    "focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-open-water-500",
  ],
  {
    variants: {
      variant: {
        item: ["whitespace-nowrap"],
        icon: ["shrink-0 h-10 w-10"],
      },
      size: {
        sm: [],
        lg: [],
      },
      active: {
        true: [],
        false: [],
      },
    },
    compoundVariants: [
      {
        variant: "item",
        size: "sm",
        className: "typography-component-xs-medium gap-1 px-3 py-2",
      },
      {
        variant: "item",
        size: "lg",
        className: "typography-component-sm-medium gap-2 px-4 py-3",
      },
      {
        active: true,
        className: "bg-open-water-500 text-white",
      },
      {
        active: false,
        className: "text-text-secondary hover:bg-grey-100",
      },
    ],
    defaultVariants: {
      variant: "item",
      size: "lg",
      active: false,
    },
  },
);
